import * as Sentry from '@sentry/browser';
import Vue from 'vue';
import { USER_FAILURE, USER_REQUEST, USER_SUCCESS } from '@/constants/types';

const InitialState = {
  current: {
    access_token: null,
    refresh_token: null,
    expires_in: null,
    role_code: null,
    role_name: null,
    first_name: null,
    last_name: null,
    server_date: null,
    scopes: null,
    hashScopes: null,
    email: null,
    user_id: null,
    has_logged_in: false,
    phone_number: null,
  },
  [`${USER_REQUEST}`]: false,
  [`${USER_SUCCESS}`]: false,
  [`${USER_FAILURE}`]: false,
};

const mutations = {
  update(state, _current) {
    const hashScopes = (_current.scopes && _current.scopes.reduce((_, cur) => {
      const prev = _;
      prev[cur] = cur;
      return prev;
    }, {})) || {};
    const current = { ..._current, hashScopes };
    try {
      if (current.email !== null) {
        if (Sentry) {
          Sentry.setUser({
            id: current.user_id,
            email: current.email,
            username: current.role_name,
          });
        }

        if (window.ga) {
          window.ga('set', 'userId', current.user_id);
        }
      }
    } catch (e) {
      Vue.config.errorHandler(e);
    }
    return Object.assign(state, { current });
  },
  [`${USER_REQUEST}`](state, status) {
    Object.assign(state, { [`${USER_REQUEST}`]: status });
  },
  [`${USER_FAILURE}`](state, error) {
    Object.assign(state, { [`${USER_FAILURE}`]: error });
  },
  [`${USER_SUCCESS}`](state, response) {
    Object.assign(state, { [`${USER_SUCCESS}`]: response });
  },
};

const actions = {
  update({ commit }, payload) {
    try {
      commit('update', payload);
      commit(USER_REQUEST, false);
      commit(USER_SUCCESS, true);
    } catch (error) {
      commit(USER_REQUEST, false);
      commit(USER_FAILURE, true);
      Vue.config.errorHandler(error);
    }
  },
};

const getters = {
  user: (state) => state.current,
};

export default {
  state: InitialState,
  mutations,
  actions,
  getters,
  namespaced: true,
};
